import { render, staticRenderFns } from "./UserAddressConfirmRemoveDialog.vue?vue&type=template&id=de9aa444&"
import script from "./UserAddressConfirmRemoveDialog.vue?vue&type=script&lang=js&"
export * from "./UserAddressConfirmRemoveDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports